import {
  Box,
  Checkbox,
  Divider,
  Drawer,
  FormControlLabel,
  IconButton,
  Typography,
} from '@mui/material';
import { Space } from '@signal-os/lock-space-meili-docs-types';
import { useTranslation } from 'react-i18next';
import { X } from 'src/icons/x';
import { useSettingsStore } from 'src/store/settings-store';

interface Props {
  open: boolean;
  onCancelSelectedAction: () => void;
  onClose: () => void;
  selectedBookingToken: string;
  otherAvailableSpaces: Space[];
  onSelectSpace: (
    bookingToken: string,
    spaceToken: string,
    checked: boolean,
  ) => void;
  bookingSpaceReplacementToken: string;
}

export const DeleteSpaceDialogSpacesDrawer = ({
  open,
  onCancelSelectedAction,
  onClose,
  selectedBookingToken,
  otherAvailableSpaces,
  onSelectSpace,
  bookingSpaceReplacementToken,
}: Props) => {
  const { t } = useTranslation(['spaces']);

  const settingsTheme = useSettingsStore(state => state.theme);

  const handleClose = () => {
    const hasChosenSpace = otherAvailableSpaces.some(
      space => space.token === bookingSpaceReplacementToken,
    );

    if (!hasChosenSpace) {
      onCancelSelectedAction();
    }

    onClose();
  };

  return (
    <Drawer
      sx={{ height: '100%', zIndex: '1301 !important' }}
      anchor="right"
      open={open}
      onClose={handleClose}>
      <Box
        sx={{
          width: 380,
          overflowY: 'auto',
        }}
        role="presentation">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
            position: 'absolute',
            top: 0,
            width: '100%',
            backgroundColor: 'background.default',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor:
              settingsTheme === 'light' ? '#e1e3ea' : '#2b2f3c',
            zIndex: 99999,
          }}>
          <Typography color="textPrimary" variant="subtitle1">
            {t('spaces:common.deleteSpaceDialog.chooseSpace')}
          </Typography>

          <IconButton onClick={handleClose} size="small">
            <X fontSize="small" sx={{ color: 'text.primary' }} />
          </IconButton>
        </Box>
        <Divider />

        <Box sx={{ minHeight: '100vh', pt: '61px', pb: '70px' }}>
          {otherAvailableSpaces.map(space => (
            <Box key={space.token} sx={{ p: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="space"
                    checked={bookingSpaceReplacementToken === space.token}
                    onChange={event =>
                      onSelectSpace(
                        selectedBookingToken,
                        space.token,
                        event.target.checked,
                      )
                    }
                  />
                }
                label={space.name}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Drawer>
  );
};
